import { FontSize } from "config/font";
import { useState } from "react";
import {
  EyeIcon,
  InputContainer,
  InputLabel,
  TextInput,
} from "./textInput.styled";
import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";

interface TextInputWithLabelProps {
  label: string;
  required?: boolean;
  hasError?: boolean;
  fontSize?: FontSize;
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  maxLength?: number;
  errorText?: string;
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputSize?: "medium" | "small";
  width?: number;
}

export const Eye = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export const TextInputWithLabel: React.FC<TextInputWithLabelProps> = (
  props
) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = Boolean(props.value && props.value.length > 0);
  const sizeVariant = props.inputSize ?? "medium";

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    props.onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    props.onBlur?.(e);
  };

  return (
    <>
      <InputContainer
        marginLeft={props.marginLeft}
        marginRight={props.marginRight}
        marginTop={props.marginTop}
        marginBottom={props.marginBottom}
        width={props.width}
      >
        <InputLabel
          required={props.required}
          hasValue={hasValue}
          isFocused={isFocused}
          $size={sizeVariant}
        >
          {props.label}
        </InputLabel>
        <TextInput
          type={props.type ?? "text"}
          value={props.value}
          onChange={props.onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          hasError={props.hasError}
          fontSize={props.fontSize}
          disabled={props.disabled}
          hasValue={hasValue}
          $size={sizeVariant}
          maxLength={props.maxLength}
          onKeyDown={props.onKeyDown}
          placeholder={props.placeholder}
        />

        {props.disabled && (
          <EyeIcon>
            <Eye size={sizeVariant === "small" ? 12 : 16} />
          </EyeIcon>
        )}

        {props.errorText && (
          <Text
            fontSize={FontSize.Tiny}
            color={Color.LighterDestructive}
            style={{ marginTop: 6, width: 280 }}
          >
            {props.errorText}
          </Text>
        )}
      </InputContainer>
    </>
  );
};
